{
  "app": {
    "name": "Planella Beauty",
    "tagline": "היומן שלך, בלי כאב ראש."
  },
  "promise": {
    "1": {
      "title": "קובעים תור ב-30 שניות. בלי אפליקציה.",
      "sub": "בלי חשבון, בלי הורדה."
    },
    "2": {
      "title": "הלקוחות באמת מגיעים.",
      "sub": "תזכורות, מקדמה ורשימת המתנה."
    },
    "3": {
      "title": "מחיר אחד. אפס עמלות. אפס הפתעות.",
      "sub": "בלי עמלה על אף תור."
    }
  },
  "nav": {
    "aria": "ניווט ראשי",
    "today": "היום",
    "calendar": "יומן",
    "clients": "לקוחות",
    "me": "אני",
    "add": "הוסיפו תור"
  },
  "btn": {
    "save": "שמרו",
    "cancel": "ביטול",
    "back": "חזרה",
    "next": "המשיכו",
    "done": "סגרו",
    "close": "סגרו",
    "undo": "החזירו",
    "retry": "נסו שוב",
    "edit": "ערכו",
    "delete": "מחקו",
    "copy": "העתיקו",
    "share": "שתפו",
    "confirm": "אשרו",
    "open": "פתחו",
    "add": "הוסיפו",
    "skip": "דלגו",
    "send": "שלחו",
    "reset": "אפסו",
    "all": "הכל",
    "more": "עוד",
    "call": "חיוג",
    "whatsapp": "וואטסאפ",
    "navigate": "ניווט",
    "search": "חיפוש",
    "clear": "נקו",
    "remove": "הסירו",
    "upgrade": "שדרגו",
    "reveal": "הציגו",
    "hide": "הסתירו",
    "install": "התקינו",
    "home": "לדף הבית"
  },
  "field": {
    "name": "שם",
    "phone": "טלפון",
    "phoneHint": "050-1234567",
    "notes": "הערות",
    "price": "מחיר",
    "duration": "משך",
    "optional": "לא חובה"
  },
  "err": {
    "required": "שדה חובה",
    "phone": "הטלפון לא נראה תקין. נסו 050-1234567",
    "name": "מה השם?",
    "otp": "הקוד לא נכון. נסו שוב.",
    "generic": "משהו השתבש. נסו שוב.",
    "network": "אין חיבור לאינטרנט.",
    "notFound": "לא מצאנו את זה."
  },
  "a11y": {
    "timeLater": "רבע שעה מאוחר יותר",
    "timeEarlier": "רבע שעה מוקדם יותר",
    "errors_one": "שגיאה אחת בטופס",
    "errors_two": "שתי שגיאות בטופס",
    "errors_other": "{count} שגיאות בטופס",
    "skip": "דלגו לתוכן",
    "closeSheet": "סגרו חלונית",
    "loading": "טוענים",
    "toast": "הודעה",
    "selected": "נבחר",
    "sensitive": "מידע רגיש, מוסתר"
  },
  "status": {
    "awaiting_deposit": "ממתין למקדמה",
    "pending": "ממתין לאישור",
    "confirmed": "אושר",
    "completed": "בוצע",
    "cancelled_client": "בוטל על ידי הלקוח",
    "cancelled_owner": "בוטל",
    "no_show": "לא הגיע",
    "msg": {
      "queued": "בתור לשליחה",
      "sent": "נשלח",
      "delivered": "נמסר",
      "failed": "נכשל",
      "suppressed": "לא נשלח"
    },
    "wl": {
      "waiting": "ממתין",
      "offered": "הוצעה שעה",
      "booked": "נקבע",
      "expired": "פג תוקף"
    },
    "deposit": {
      "pending": "מקדמה בהמתנה",
      "paid": "מקדמה שולמה",
      "failed": "התשלום נכשל",
      "expired": "המקדמה פגה"
    },
    "noReminders": "ללא תזכורות"
  },
  "days": {
    "long": {
      "sun": "יום ראשון",
      "mon": "יום שני",
      "tue": "יום שלישי",
      "wed": "יום רביעי",
      "thu": "יום חמישי",
      "fri": "יום שישי",
      "sat": "שבת"
    },
    "short": {
      "sun": "א׳",
      "mon": "ב׳",
      "tue": "ג׳",
      "wed": "ד׳",
      "thu": "ה׳",
      "fri": "ו׳",
      "sat": "ש׳"
    }
  },
  "months": {
    "long": {
      "jan": "ינואר",
      "feb": "פברואר",
      "mar": "מרץ",
      "apr": "אפריל",
      "may": "מאי",
      "jun": "יוני",
      "jul": "יולי",
      "aug": "אוגוסט",
      "sep": "ספטמבר",
      "oct": "אוקטובר",
      "nov": "נובמבר",
      "dec": "דצמבר"
    }
  },
  "time": {
    "today": "היום",
    "tomorrow": "מחר",
    "yesterday": "אתמול",
    "now": "עכשיו",
    "morning": "בוקר",
    "noon": "צהריים",
    "evening": "ערב",
    "anyTime": "הכל",
    "dayTime": "{day} · {time}"
  },
  "duration": {
    "min": "{n} דק׳",
    "hm": "{h} שע׳ {m} דק׳"
  },
  "price": {
    "from": "מ-{price}",
    "free": "חינם",
    "perMonth": "{price} לחודש",
    "perYear": "{price} לשנה"
  },
  "unit": {
    "appointments_one": "תור אחד",
    "appointments_two": "שני תורים",
    "appointments_other": "{count} תורים",
    "clients_one": "לקוח אחד",
    "clients_two": "שני לקוחות",
    "clients_other": "{count} לקוחות",
    "waiting_one": "ממתין אחד",
    "waiting_two": "שני ממתינים",
    "waiting_other": "{count} ממתינים",
    "messages_one": "הודעה אחת",
    "messages_two": "שתי הודעות",
    "messages_other": "{count} הודעות",
    "days_one": "יום אחד",
    "days_two": "יומיים",
    "days_other": "{count} ימים",
    "visits_one": "ביקור אחד",
    "visits_two": "שני ביקורים",
    "visits_other": "{count} ביקורים",
    "hours_one": "שעה",
    "hours_two": "שעתיים",
    "hours_other": "{count} שעות",
    "slots_one": "שעה פנויה אחת",
    "slots_two": "שתי שעות פנויות",
    "slots_other": "{count} שעות פנויות",
    "services_one": "שירות אחד",
    "services_two": "שני שירותים",
    "services_other": "{count} שירותים",
    "minutes_one": "דקה",
    "minutes_two": "שתי דקות",
    "minutes_other": "{count} דקות"
  },
  "profession": {
    "nails": "ציפורניים",
    "lashes": "ריסים",
    "brows": "גבות",
    "barber": "ספרות",
    "hair": "שיער",
    "cosmetics": "קוסמטיקה",
    "skin": "טיפוח עור",
    "waxing": "הסרת שיער",
    "makeup": "איפור"
  },
  "toast": {
    "saved": "נשמר",
    "copied": "הועתק",
    "linkCopied": "הלינק הועתק",
    "deleted": "נמחק",
    "apptAdded": "התור נוסף",
    "apptMoved": "התור הוזז ל-{when}",
    "apptCancelled": "התור בוטל",
    "apptCancelledNotified": "התור בוטל. הלקוח יקבל הודעה.",
    "apptCancelledSilent": "התור בוטל. אין הסכמה להודעות.",
    "apptDone": "סומן כבוצע",
    "noShow": "סומן: לא הגיע",
    "paid": "סומן כשולם",
    "clientAdded": "הלקוח נוסף",
    "offerSent_one": "ההצעה נשלחה לממתין אחד",
    "offerSent_two": "ההצעה נשלחה לשני ממתינים",
    "offerSent_other": "ההצעה נשלחה ל-{count} ממתינים",
    "slotFilled": "השעה נתפסה: {name}. התור נקבע.",
    "firstBooking": "התור הראשון הגיע!",
    "linkReady": "הלינק מוכן",
    "demoReset": "הדמו התחיל מחדש",
    "clockJump": "השעון קפץ ל-{when}",
    "langChanged": "השפה הוחלפה",
    "undone": "הפעולה הוחזרה",
    "offline": "אין חיבור. נשמור וננסה שוב.",
    "online": "החיבור חזר"
  },
  "offline": {
    "banner": "אין חיבור. השינויים נשמרים ויסונכרנו כשיחזור.",
    "bookingBlocked": "אין חיבור, אז אי אפשר לקבוע עכשיו."
  },
  "demo": {
    "banner": {
      "text": "מצב דמו · הכל הדמיה",
      "reset": "אפסו דמו"
    },
    "badge": {
      "whatsapp": "הדמיית וואטסאפ · לא נשלחה הודעה אמיתית",
      "payment": "הדמיית תשלום · לא בוצע חיוב",
      "otp": "קוד הדמיה: {code}",
      "estimate": "הערכה לפי מחירון"
    }
  },
  "consent": {
    "version": "v2",
    "reminders": {
      "v2": {
        "text": "הודעות וואטסאפ על התור מ{business}",
        "hint": "אישור, תזכורת ועדכונים. אפשר להסיר בכל רגע."
      }
    },
    "marketing": {
      "v2": {
        "text": "פרסומות מ{business} בוואטסאפ",
        "hint": "אפשר להסיר בכל רגע בהודעה \"הסר\"."
      }
    },
    "purpose": {
      "reminders": "תזכורות ועדכונים",
      "marketing": "פרסומות"
    },
    "since": "אושר ב-{date}",
    "revoked": "הוסר ב-{date}",
    "none": "אין הסכמה"
  },
  "policy": {
    "cancel": {
      "free": "ביטול עד {hours} שעות לפני התור: ללא חיוב.",
      "fee": "ביטול בתוך {hours} שעות: חיוב {fee}.",
      "none": "אפשר לבטל בכל רגע, ללא חיוב.",
      "inside": "אתם בתוך חלון הביטול. ביטול עכשיו: חיוב {fee}.",
      "outside": "ביטול עכשיו: ללא חיוב."
    },
    "noshow": "אי הגעה בלי ביטול: חיוב {fee}.",
    "deposit": "מקדמה {amount}. מנוכה מהמחיר.",
    "depositRefund": "המקדמה מוחזרת בביטול עד {hours} שעות לפני."
  },
  "privacy": {
    "line": "הפרטים נשמרים אצל {business} לצורך התור בלבד.",
    "more": "עוד על פרטיות",
    "title": "פרטיות בקצרה",
    "collect": "{business} אוספת שם וטלפון כדי לקבוע ולנהל את התור.",
    "use": "משתמשים בפרטים לאישור, תזכורת ועדכונים, ורק אם סימנתם הסכמה.",
    "see": "הפרטים גלויים ל-{business} ול-Planella, שמפעילה את הדף. לא מוכרים אותם.",
    "rights": "אפשר לבקש עיון, תיקון או מחיקה בכל רגע: {contact}",
    "demoNote": "בדמו הפרטים נשמרים רק בדפדפן הזה.",
    "erase": "למחיקה מיידית: פתחו את קישור התור מההודעה ולחצו ״מחקו את הפרטים שלי״.",
    "eraseLink": "מחקו את הפרטים שלי"
  },
  "share": {
    "bookingLink": "קבעו תור ב-{business}: {link}",
    "appt": "יש לי תור ב-{business}: {service}, {date} בשעה {time}"
  },
  "ics": {
    "title": "{service} · {business}"
  },
  "install": {
    "title": "הוסיפו למסך הבית",
    "sub": "פתיחה מהירה, גם בלי חיבור.",
    "ios": "לחצו על שיתוף ואז \"הוסיפו למסך הבית\"."
  },
  "lang": {
    "he": "עברית",
    "en": "אנגלית",
    "ar": "العربية"
  },
  "ui": {
    "required": "חובה",
    "dayPick": "בחירת יום",
    "timePick": "בחירת שעה",
    "stepOf": "שלב {index} מתוך {count}",
    "progress": "התקדמות",
    "newCount": "{n} חדשים",
    "copyLink": "העתקת הקישור",
    "copied": "הועתק",
    "deposit": "מקדמה",
    "simulated": "הדמיה, לא נשלח",
    "errTitle": "משהו השתבש",
    "errBody": "זה לא אתם, זה אנחנו. נסו שוב.",
    "newAppt": "תור חדש",
    "back": "חזרה",
    "close": "סגירה",
    "toasts": "הודעות",
    "st": {
      "pending": "ממתין לאישור",
      "confirmed": "אושר",
      "deposit": "ממתין למקדמה",
      "cancelled": "בוטל",
      "noshow": "לא הגיע",
      "completed": "הושלם"
    }
  }
}
